// These will be removed in v4
var VIEWPORTS = {
  XS: 480,
  SM: 768,
  MD: 992,
  LG: 1200,
  XL: 1900
};

// min-width breakpoints for common devices
var BREAKPOINTS = {
  // These will be removed in v4
  PHONE_PORTRAIT_MED: 375,
  PHONE_PORTRAIT_LG: 576,
  DESKTOP_SM: 1024,
  DESKTOP_HD: 1600,
  MAX_768: 767.98,
  MAX_1024: 1023.98,
  MAX_1280: 1279.98,
  MAX_1600: 1599.98,
  // These are go forward
  PHONE_PORTRAIT_SM: 320,
  TABLET_PORTRAIT: 768,
  DESKTOP_MED: 1280,
  DESKTOP_LG: 1440,
  DESKTOP_XL: 1920
};
var GRID_BREAKPOINTS_CANADIAN = {
  XL: 1600,
  L: 1439,
  M: 1279,
  S: 599,
  XS: 319
};
var GRID_BREAKPOINTS_CONNECTED = {
  DESKTOP: 1919,
  TABLET_DESKTOP: 1279,
  TABLET: 1023,
  MOBILE: 767
};

export { BREAKPOINTS, GRID_BREAKPOINTS_CANADIAN, GRID_BREAKPOINTS_CONNECTED, VIEWPORTS };
